import { ReactNode } from 'react';

interface SectionProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  id?: string;
}

export function Section({ title, subtitle, children, id }: SectionProps) {
  return (
    <section id={id} className="py-16 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{title}</h2>
          {subtitle && <p className="text-xl text-gray-600 dark:text-gray-300">{subtitle}</p>}
        </div>
        {children}
      </div>
    </section>
  );
}